export enum Langs {
    cz = 'cz',
    sk = 'sk',
}

interface Message {
    [index: string] : string
}

export type Messages = {
    [key in Langs] : Message
}

export default class Translator {
    private messages: Messages
    private lang: Langs
    private fallback: Langs

    constructor (messages: Messages, lang: Langs, fallback: Langs) {
        this.messages = messages
        this.lang = lang
        this.fallback = fallback
    }

    translate = (key: string) => this.messages[this.lang][key] ? this.messages[this.lang][key] : this.messages[this.fallback][key] ? this.messages[this.fallback][key] : key
}
